import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Package } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeader, Loading, EmptyState, Tag } from "@/components/brand";
import { formatR } from "@/lib/format";
import dayjs from "dayjs";

export default function Orders() {
  const orders = useQuery({ queryKey: ["orders"], queryFn: () => api("/orders/me") });
  const tone = (s) => s === "delivered" ? "green" : s === "pending_payment" ? "dark" : s === "cancelled" ? "grey" : "pink";
  return (
    <div data-testid="orders-screen" className="space-y-5">
      <SectionHeader title="My Orders" subtitle="Track your Sofit Shop purchases." />
      {orders.isLoading ? <Loading /> : (orders.data ?? []).length === 0 ? (
        <EmptyState icon={Package} title="No orders yet" subtitle="Visit the shop to buy fitness gear." />
      ) : (
        <div className="space-y-3">
          {(orders.data ?? []).map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="p-4 rounded-xl2 border border-divider">
              <div className="flex items-center justify-between">
                <div className="font-display text-lg text-ink">{o.title}</div>
                <Tag label={o.status === "pending_payment" ? "awaiting payment" : o.status} tone={tone(o.status)} />
              </div>
              <div className="font-body text-xs text-mutedgrey">{dayjs(o.created_at).format("D MMM YYYY, HH:mm")}</div>
              <div className="flex gap-2 mt-3 overflow-x-auto no-scrollbar">
                {o.items.map((it, i) => <img key={i} src={it.image} alt={it.name} title={`${it.qty} × ${it.name}`} className="w-12 h-12 rounded-md object-cover shrink-0" />)}
              </div>
              <div className="flex justify-between mt-3 font-body text-sm"><span className="text-mutedgrey">Total ({o.items.length} item{o.items.length > 1 ? "s" : ""})</span><span className="font-display text-brand">{formatR(o.total)}</span></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
